// ──────────────────────────────────────────────────────────────────────────
// Quién puede evaluar la Clase Modelo de una postulación.
//
// Es el evaluador asignado (TP_ClaseModelo.IdEmpleadoEvaluador) o su suplente vigente
// para esa postulación. NO depende del rol Director de Colegio: antes cualquier Director
// de la sede del candidato veía el ícono de evaluar aunque no fuera el evaluador, y un
// evaluador sin ese rol (p. ej. un suplente) no podía usar la pantalla. El servidor tiene
// la última palabra (validarEnvioEvaluacionClaseModelo); esto solo evita ofrecer la acción
// a quien no le corresponde.
//
// `row` es la fila de la bandeja (idEmpleadoEvaluador y esSuplenteVigente los calcula la
// Lambda); `idEmpleadoSesion` sale de getIdEmpleadoSesion(state) (utils/sesion.js).
// ──────────────────────────────────────────────────────────────────────────
export const esEvaluadorClaseModelo = (row, idEmpleadoSesion) => {
    if (!row) return false;
    if (row.esSuplenteVigente) return true;
    if (idEmpleadoSesion == null || row.idEmpleadoEvaluador == null) return false;
    return Number(row.idEmpleadoEvaluador) === Number(idEmpleadoSesion);
};
